































import { Component, Vue, PropSync, Emit, Prop } from "vue-property-decorator";
import { Owner } from '@/api/owner/types';

@Component({
  name: "OwnersDeleteModal",
})
export default class OwnersDeleteModal extends Vue {
  @Prop({ type: Boolean, default: false })
  private modal!: boolean;

  @Prop({ type: Owner, required: false }) 
  private owner !: Owner | null;

  public ownerDelete() {
    this.$emit("onsubmit", this.owner);
  }

  @Emit("oncancel")
  public closeOwnerDelete() {
  }
}
